/** Prefix used to mark hidden system-context messages in chat. */
export const HIDDEN_CONTEXT_PREFIX = "<!--SYSTEM_CONTEXT-->";

export const BRAND_MARKUP = 0;

/** ElevenLabs STT cost in microdollars for a given duration. Based on $0.40/hour pricing. */
export function calculateElevenLabsSttCost(durationSeconds: number): number {
  const costPerSecond = (0.4 / 3600) * 1_000_000;
  return Math.round(durationSeconds * costPerSecond * (1 + BRAND_MARKUP));
}

/** Fixed cost per CLI render in microdollars (free, all edits cost nothing). */
export const CLI_RENDER_COST_MICRODOLLARS = 0;

/** Minimum cost per Apify scrape in microdollars ($0.001 = 1000 microdollars) */
export const APIFY_MIN_SCRAPE_COST_MICRODOLLARS = 1000;

// Retry configuration for inference jobs
// 3 retries means 4 total attempts (1 initial + 3 retries)
export const INFERENCE_RETRY_TIMES = 3;

// Retry configuration for transient provider errors (service overloaded, temporary outage)
// 10 retries means 11 total attempts (1 initial + 10 retries)
export const INFERENCE_TRANSIENT_RETRY_TIMES = 10;

/**
 * Tank (multi-product auth): the product tenant every account belongs to
 * today. account.email is unique per (product, email), so exact account
 * lookups by email must be scoped to a product — pass this constant
 * explicitly so call sites stay greppable when product #2 lands.
 */
export const DEFAULT_PRODUCT = "wonda";

// src/constants.ts (or whatever file now holds your IMAGE_MODELS)
export const PUBLIC_APP_NAME = "Wondercat";
export const BASE_APP_URL_PROD = "https://app.wondercat.ai";

export const DEFAULT_CURRENCY = "usd";
export const DEFAULT_LOCALE = "en-US";

export const LANDING_PAGE_URL = "https://wondercat.ai";
export const TERMS_OF_SERVICE_URL = `${LANDING_PAGE_URL}/tos`;
export const ACCEPTABLE_MEDIA_URL = TERMS_OF_SERVICE_URL;
export const PRIVACY_URL = `${LANDING_PAGE_URL}/privacy`;

export const CONTACT_EMAIL = "contact@wondercat.ai";
export const SUPPORT_EMAIL = "contact@wondercat.ai";

export const GOOGLE_FAVICON_URL =
  "https://www.google.com/s2/favicons?sz=64&domain_url=";

export const DEFAULT_VIDEO_DURATION_IN_SECONDS = 8;

export const MAX_IMAGE_SIZE_IN_BYTES = 50_000_000; // 10MB
export const MAX_VIDEO_SIZE_IN_BYTES = 2_000_000_000; // 2GB

export const LAST_STEP_OUTPUT_MEDIA_ID = "last_step_output";

/** Placeholder name shown while AI generates a descriptive node name */
export const GENERATING_NAME_PLACEHOLDER = "Generating...";

export const MEDIA_ASPECT_RATIOS = {
  "Horizontal (16:9)": "16:9",
  "Vertical (9:16)": "9:16",
  // "Square (1:1)": "1:1",
};

/**
 * Platform-wide default generation parameters.
 * Applied when the LLM doesn't explicitly override them via paramOverrides.
 * getBlueprintSchema flags nodes whose values differ from these as platformDefaultConflict.
 */
export const PLATFORM_GENERATION_DEFAULTS: Record<string, string> = {
  aspectRatio: "9:16",
};

// Re-export AppSetting from dedicated module with type-safe schemas
export { AppSetting } from "./appSettings";
